import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import AuthShell from './AuthShell';
import { AuthShellConfigContext } from './lib/AuthShellConfigContext';

// Route layout that keeps ONE AuthShell mounted across the auth routes it
// wraps (login, forgot password, reset), so navigation between them only
// swaps the card content instead of remounting the background and card.
const AuthShellLayout = ({ theme = 'light' }) => {
  const [config, setConfig] = useState({});

  return (
    <AuthShellConfigContext.Provider value={setConfig}>
      <AuthShell theme={theme} backTo={config.backTo} onBack={config.onBack}>
        <Outlet />
      </AuthShell>
    </AuthShellConfigContext.Provider>
  );
};

export default AuthShellLayout;
